export const DOMAIN = "https://api-hub.services.neurobit.com"; // prod
// export const DOMAIN = "https://api-hub.staging.neurobit.com"; // staging
// export const DOMAIN = "http://127.0.0.1:8000"; // dev
export const CUSTOM_CATEGORY_NAME = "custom"
